import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { ListItemIcon, ListItemText } from '@mui/material';

export type Action = {
  label: string;
  icon?: React.ReactNode;
  hidden?: boolean;
  onClick: () => void;
}

export interface MoreActionsProps {
  options: Action[];
}

const ITEM_HEIGHT = 48;

export default function MoreActions({ options }: MoreActionsProps) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOptionClick = (option: Action) => {
    option.onClick();
    handleClose();
  }

  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: '20ch',
            },
          },
          list: {
            'aria-labelledby': 'long-button',
          },
        }}
      >
        {options.filter(option => !option.hidden).map((option) => (
          <MenuItem key={option.label} onClick={() => handleOptionClick(option)}>
          <ListItemIcon>
            {option.icon}
          </ListItemIcon>
          <ListItemText>{option.label}</ListItemText>
        </MenuItem>
        ))}
      </Menu>
    </div>
  );
}
